import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, renderList as _renderList, createSlots as _createSlots, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f4a6a01"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "handle-btns" }

import LfTable from '@/components/LfTable.vue'
import { usePermission } from '@/hooks/usePermission'
import { useStore } from '@/store'
import { ElLoading, ElMessage, ElMessageBox  } from 'element-plus'
import { resetPassword } from '@/service/account/account'
import {
  computed,
  nextTick,
  ref,
  watch,
  withDefaults
} from 'vue'
import { ILoadingInstance } from 'element-plus/lib/el-loading/src/loading.type'
import localCache from '@/utils/cache'
import { getListData } from '@/service/main/system'


export default /*#__PURE__*/_defineComponent({
  __name: 'PageContent',
  props: {
    contentTableConfig: {},
    pageName: {},
    pageUrl: {},
    delUrl: {},
    downUrl: {},
    pageSize: {},
    deleteTip: { default: '确认删除吗?' },
    downFilename: {},
    summaryFilename: {},
    filterRules: {},
    usePost: { type: Boolean }
  },
  emits: ["newBtnClick", "batchBtnClick", "editBtnClick", "goToAliyunClick", "selectionChange", "rowClick", "sortChange", "fillBtnClick", "downBtnClick", "dailyExportClick", "transformationClick1", "transformationClick2", "dealCustomerClick", "conversionSummaryClick", "summaryBtnClick", "historyBtnClick", "activityRankingClick", "hotRankingClick", "batchEditAccountBtnClick", "batchEditCustomerBtnClick", "detailClick", "viewClick", "verifyClick", "revokeClick", "crossClick", "batchEditPointClick", "batchUpdateChannelClick", "configClick", "configUnionIdClick", "rtContentClick", "qrCodeClick", "voiceFinance", "voiceExport", "voiceSum", "voiceEveryDay", "voiceDetail", "overtimeData", "worktimeData", "materialSum", "batchDeleteBtnClick", "batchSetBtnClick", "batchCancelBtnClick", "mouseEnter", "mouseLeave", "ybwaveSum", "ybwaveDetail", "ybwaveDownloadImport", "importProgress", "importSuccess", "importError", "exportStatistic", "exportStatisticDetail", "loadScript", "columnShow", "receiveAll", "updateAll", "financeDownload", "columnEdit", "createTable", "changeTime"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const store = useStore()
store.commit('system/changeOrderInfo', {})

const openOrClose = () => {
  store.commit('system/changeOpenOrClose', !store.state.system.openOrClose)
}

const isScriptLoading = ref(false)

const props = __props

const emit = __emit

const headers = ref({})
const token = localCache.getCache('token')
headers.value = {
  Authorization: `Bearer ${token}`
}

// 获取操作权限
const isCreate = usePermission(props.pageName, 'create')
const isQuery = usePermission(props.pageName, 'list')
const isUpdate = usePermission(props.pageName, 'update')
const isGoToAliyun = usePermission(props.pageName, 'goToAliyun')
const isDelete = usePermission(props.pageName, 'delete')
const isBatch = usePermission(props.pageName, 'updateBatch')

const isInitImport = usePermission(props.pageName, 'initImport')
const isImportData = usePermission(props.pageName, 'importData')
const isFinanceDownload = usePermission(props.pageName, 'financeDownload')

const isReset =
  usePermission('employee', 'reset') && props.pageName == 'employee'

const isFill = usePermission(props.pageName, 'fill')
const isDownload = usePermission(props.pageName, 'download')
const isDownloadData = usePermission(props.pageName, 'downloadData')
const isDealCustomer = usePermission(props.pageName, 'dealCustomer')
const isConversionSummary = usePermission(props.pageName, 'conversionSummary')
const isSummary = usePermission(props.pageName, 'summary')
const isHistory = usePermission(props.pageName, 'history')
const isBatchEditAccount = usePermission(props.pageName, 'batchEditAccount')
const isBatchEditCustomer = usePermission(props.pageName, 'batchEditCustomer')
const isDetail = usePermission(props.pageName, 'detail')
const isView = usePermission(props.pageName, 'view')
const isVerify = usePermission(props.pageName, 'verify')
const isRevoke = usePermission(props.pageName, 'revoke')
const isCross = usePermission(props.pageName, 'cross')
const isBatchEditPoint = usePermission(props.pageName, 'batchEditPoint')
const isBatchUpdateChannel = usePermission(props.pageName, 'batchUpdateChannel')
const isConfig = usePermission(props.pageName, 'config')
const isConfigUnionId = usePermission(props.pageName, 'configUnionId')
const isRtContent = usePermission(props.pageName, 'rtContent')
const isQrcode = usePermission(props.pageName, 'qrCode')
const isActivityRanking = usePermission(props.pageName, 'activityRanking')
const isHotRanking = usePermission(props.pageName, 'hotRanking')

const isFinance = usePermission(props.pageName, 'finance')
const isExport = usePermission(props.pageName, 'export')
const isExportDetail = usePermission(props.pageName, 'exportDetail')
const isExportOvertimeData = usePermission(props.pageName, 'exportOvertimeData')
const isExportWorktimeData = usePermission(props.pageName, 'exportWorktimeData')
const isExportMaterial = usePermission(props.pageName, 'exportMaterial')

const isBatchDelete = usePermission(props.pageName, 'batchDelete')
const isBatchSet = usePermission(props.pageName, 'batchSet')
const isBatchCancel = usePermission(props.pageName, 'batchCancel')

const isYbwaveExportSum = usePermission(props.pageName, 'ybwaveExportSum')
const isYbwaveExportDetail = usePermission(props.pageName, 'ybwaveExportDetail')
const isYbwaveDownloadImport = usePermission(
  props.pageName,
  'ybwaveDownloadImport'
)
const isYbwaveImport = usePermission(props.pageName, 'ybwaveImport')

const isExportStatistic = usePermission(props.pageName, 'exportStatistic')
const isExportStatisticDetail = usePermission(
  props.pageName,
  'exportStatisticDetail'
)
const isLoadScript = usePermission(props.pageName, 'loadScript')
const isShowColumn = usePermission(props.pageName, 'showColumn')
const isAllReceive = usePermission(props.pageName, 'allReceive')
const isAllUpdate = usePermission(props.pageName, 'allUpdate')
const isDailyExport = usePermission(props.pageName, 'dailyExport')
const isTransformation1 = usePermission(props.pageName, 'transformation1')
const isTransformation2 = usePermission(props.pageName, 'transformation2')

const columnEdit = usePermission(props.pageName, 'columnEdit')
const createTable = usePermission(props.pageName, 'createTable')

const pageInfo = ref({
  pageNo: 1,
  pageSize: props.pageSize ? props.pageSize : 10
})
let queryParam = {}
let query = {}

const showVerifyButton = (row: any) => {
  return isVerify && row.verifyResult != '1'
}

const showRevokeButton = (row: any) => {
  return isRevoke && row.verifyResult == '1'
}

const showCrossButton = (row: any) => {
  return isCross && row.applyStatus != '1'
}

const showDeleteButton = (row: any) => {
  return isDelete && row.verifyResult != '1' && row.raffleStatus != '1'
}

const handleSlectionChange = (value: any[]) => {
  emit('selectionChange', value)
}

const handleSortChange = (value: any) => {
  emit('sortChange', value)
}

const handleRowClick = (row: any, cloumn: any) => {
  emit('rowClick', row, cloumn)
}

const handleMouseEnter = (
  row: any,
  column: any,
  cell: HTMLElement,
  event: MouseEvent
) => {
  emit('mouseEnter', row, column, cell, event)
}

const handleMouseLeave = (
  row: any,
  column: any,
  cell: HTMLElement,
  event: MouseEvent
) => {
  emit('mouseLeave', row, column, cell, event)
}

//定义请求数据的方法
const getPageData = (queryInfo: any = {}, callBack?: any) => {
  query = queryInfo
  queryParam = {
    ...queryInfo,
    pageNo: pageInfo.value.pageNo,
    pageSize: pageInfo.value.pageSize
  }
  store.commit('system/changeQueyryInfo', queryParam)

  nextTick(() => {
    refreshFunc(callBack)

  })
}

const exportXlsx = (queryInfo: any = {}) => {
  getPageData(store.state.system.queryInfo)
  if (!isQuery) return
  store.dispatch('system/exportXlsxAction', {
    pageName: props.pageName,
    queryInfo: queryParam,
    filename: props.downFilename,
    downUrl: props.downUrl
  })
}

const exportSummaryXlsx = (queryInfo: any = {}) => {
  getPageData(store.state.system.queryInfo)
  if (!isQuery) return
  store.dispatch('system/exportSummaryXlsx', {
    pageName: props.pageName,
    queryInfo: queryParam,
    filename: props.summaryFilename
  })
}

const setInitParam = (queryInfo: any = {}) => {
  queryParam = {
    pageNo: pageInfo.value.pageNo,
    pageSize: pageInfo.value.pageSize,
    ...queryInfo
  }
  store.commit('system/changeQueyryInfo', queryParam)
}
let loadingInstance: ILoadingInstance = {} as ILoadingInstance

const refreshFunc = (callBack?: any) => {
  if (!isQuery) return
  if (document.querySelector('.el-table__body-wrapper')) {
    if (loadingInstance && typeof loadingInstance.close == 'function') {
      loadingInstance.close()
    }
    loadingInstance = ElLoading.service({
      target: '.el-table__body-wrapper',
      text: '加载中....',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.8)',
      fullscreen: false
    })
  }
  const actionName = props.usePost ? 'system/getPostPageListAction' : 'system/getPageListAction'
  store
    .dispatch(actionName, {
      pageName: props.pageName,
      queryInfo: queryParam,
      pageUrl: props.pageUrl
    })
    .then(() => {
      if (loadingInstance && typeof loadingInstance.close == 'function') {
        loadingInstance.close()
      }
      if (callBack && typeof callBack == 'function') {
        callBack()
      }
    })
    .finally(() => {
      if (loadingInstance && typeof loadingInstance.close == 'function') {
        loadingInstance.close()
      }
    })
}

//初始化请求数据
if (!props.contentTableConfig.isAuto) {
  getPageData(store.state.system.queryInfo)

}

//获取数据
const dataList = computed(() =>
  store.getters[`system/pageListData`](props.pageName)

)
const dataCount = computed<number>(() =>
  store.getters[`system/pageCountData`](props.pageName)
)
//监听分页事件
watch(pageInfo, () => {
  getPageData(query)
})
watch(dataList, () => {
  if(props.pageName=='changeChannelStatistics'||props.pageName=='externalTeacherStatistics'){
    emit('changeTime',dataList.value[0].timeStr)

  }
})
//定义列表里的其他插槽
const otherPropSlots = props.contentTableConfig.propList.filter((item: any) => {
  if (item.slotName == 'createdTime') return false
  if (item.slotName == 'updatedTime') return false
  if (item.slotName == 'handler') return false
  return true
})

const handleDeleteClick = (item: any) => {
  if(!item.id){
    item.id=item?.templateId ? item?.templateId : item?.titleId
  }
  ElMessageBox.confirm(props.deleteTip, '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'error',
    center: true
  }).then(() => {
    store.dispatch('system/deletePageDataAction', {
      pageName:props.pageName,
      id: item.id,
      delUrl:props?.delUrl,
      pageUrl:props?.pageUrl
    }).catch(()=>{
         emit('delBtnClick',item.id)
    })
  })
}

const handleResetClick = (item: any) => {
  ElMessageBox.confirm(`确定给员工 ${item.realName} 重置密码吗？`, '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'error',
    center: true
  }).then(async () => {
    await resetPassword(item.id)
    ElMessage({
      type: 'success',
      message: '重置密码成功'
    })
  })
}

const handleNewClick = () => {
  emit('newBtnClick')
}

const handleBatchClick = () => {
  emit('batchBtnClick')
}

const handleBatchDeleteClick = () => {
  emit('batchDeleteBtnClick')
}

const handleBatchSetClick = () => {
  emit('batchSetBtnClick')
}

const handleBatchCancelClick = () => {
  emit('batchCancelBtnClick')
}

const handleEditClick = (item: any) => {
  emit('editBtnClick', item)
}

const handleGoToAliyunClick = (item: any) => {
  emit('goToAliyunClick', item)
}

const handleFillClick = () => {
  emit('fillBtnClick')
}
const handleDownloadClick = () => {
  emit('downBtnClick')
}
const handleDailyExportClick = () => {
  emit('dailyExportClick')
}
const handleTransformationClick1 = () => {
  emit('transformationClick1')
}
const handleTransformationClick2 = () => {
  emit('transformationClick2')
}
const handleDealCustomerClick = () => {
  emit('dealCustomerClick')
}
const handleConversionSummaryClick = () => {
  emit('conversionSummaryClick')
}
const handleSummaryClick = () => {
  emit('summaryBtnClick')
}
const handleHistoryClick = () => {
  emit('historyBtnClick')
}
const handleBatchEditAccountClick = () => {
  emit('batchEditAccountBtnClick')
}
const handleBatchEditCustomerClick = () => {
  emit('batchEditCustomerBtnClick')
}
const handleDetailClick = (item: any) => {
  emit('detailClick', item)
}

const handleViewClick = (item: any) => {
  emit('viewClick', item)
}

const handleRtContentClick = (item: any) => {
  emit('rtContentClick', item)
}

const handleVerifyClick = (item: any) => {
  emit('verifyClick', item)
}

const handleRevokeClick = (item: any) => {
  emit('revokeClick', item)
}

const handleCrossClick = (item: any) => {
  emit('crossClick', item)
}

const handleBatchEditPointClick = (item: any) => {
  emit('batchEditPointClick', item)
}

const handleBatchUpdateChannelClick = (item: any) => {
  emit('batchUpdateChannelClick', item)
}
const handleConfigClick = (item: any) => {
  emit('configClick', item)
}
const handleConfigUnionIdClick = (item: any) => {
  emit('configUnionIdClick', item)
}
const handleQrCodeClick = (item: any) => {
  emit('qrCodeClick', item)
}

const handleVoiceFinance = (item: any) => {
  emit('voiceFinance', item)
}

const handleVoiceExport = (item: any) => {
  emit('voiceExport', item)
}

const handleVoiceSum = (item: any) => {
  emit('voiceSum', item)
}

const handleEveryDay = (item: any) => {
  emit('voiceEveryDay', item)
}

const handleVoiceDetail = (item: any) => {
  emit('voiceDetail', item)
}

const handleOvertimeData = (item: any) => {
  emit('overtimeData', item)
}

const handleWorktimeData = (item: any) => {
  emit('worktimeData', item)
}

const handleMaterialSum = (item: any) => {
  emit('materialSum', item)
}

const handleYbwaveSum = () => {
  emit('ybwaveSum')
}

const handleYbwaveDetail = () => {
  emit('ybwaveDetail')
}
const handleYbwaveDownloadImport = () => {
  emit('ybwaveDownloadImport')
}

const handleActivityRankingClick = () => {
  emit('activityRankingClick')
}

const handleHotRankingClick = () => {
  emit('hotRankingClick')
}

const handleImportProgress = (response: any) => {
  emit('importProgress', response)
}

const handleImportSuccess = (response: any) => {
  emit('importSuccess', response)
}

const handleImportError = (error: any) => {
  emit('importError', error)
}

const handleExportStatistic = (item: any) => {
  emit('exportStatistic', item)
}

const handleExportStatisticDetail = (item: any) => {
  emit('exportStatisticDetail', item)
}

const handleLoadScript = (item: any) => {
  isScriptLoading.value = true
  emit('loadScript', () => {
    isScriptLoading.value = false
  })
}

const handleColumnShow = (item: any) => {
  emit('columnShow', item)
}

const handleReceiveAll = (item: any) => {
  emit('receiveAll', item)
}

const handleUpdateAll = (item: any) => {
  emit('updateAll', item)
}

const handleFinanceDownload = (item: any) => {
  emit('financeDownload', item)
}

const handleEditColumns = (item: any) => {
  emit('columnEdit', item)
}

const handleCreateTable = (item: any) => {
  emit('createTable', item)
}

//暴露一些方法和变量
__expose({
  getPageData,
  setInitParam,
  exportXlsx,
  exportSummaryXlsx
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", {
    class: "PageContent",
    onDblclick: openOrClose
  }, [
    _createVNode(LfTable, _mergeProps({
      listData: dataList.value,
      listCount: dataCount.value,
      onSelectionChange: handleSlectionChange,
      onSortChange: handleSortChange,
      onRowClick: handleRowClick,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave
    }, _ctx.contentTableConfig, {
      page: pageInfo.value,
      "onUpdate:page": _cache[1] || (_cache[1] = ($event: any) => ((pageInfo).value = $event)),
      tooltip: _ctx.filterRules
    }), _createSlots({
      headerHandler: _withCtx(() => [
        (_unref(isDailyExport))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "medium",
              onClick: handleDailyExportClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 每日数据导出 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isTransformation1))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              size: "medium",
              onClick: handleTransformationClick1
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 资源转化 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isTransformation2))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              type: "primary",
              size: "medium",
              onClick: handleTransformationClick2
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 上表率 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isAllReceive))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 3,
              type: "primary",
              size: "medium",
              onClick: handleReceiveAll
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 一键领取 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isAllUpdate))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 4,
              type: "primary",
              size: "medium",
              onClick: handleUpdateAll
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 一键修改 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isBatch))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 5,
              type: "primary",
              size: "medium",
              onClick: handleBatchClick
            }, {
              default: _withCtx(() => [
                _createTextVNode("批量编辑")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isCreate))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 6,
              type: "primary",
              size: "medium",
              onClick: handleNewClick
            }, {
              default: _withCtx(() => [
                _createTextVNode("新增")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isFill))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 7,
              type: "primary",
              size: "medium",
              onClick: handleFillClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 填报 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isDealCustomer))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 8,
              type: "primary",
              size: "medium",
              onClick: handleDealCustomerClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 成交客户 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isConversionSummary))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 9,
              type: "primary",
              size: "medium",
              onClick: handleConversionSummaryClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 资源转化汇总 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isDownload))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 10,
              type: "primary",
              size: "medium",
              onClick: handleDownloadClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 下载 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isDownloadData))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 11,
              type: "primary",
              size: "medium",
              onClick: handleDownloadClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 导出数据 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isSummary))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 12,
              type: "primary",
              size: "medium",
              onClick: handleSummaryClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 汇总 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isHistory))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 13,
              type: "primary",
              size: "medium",
              onClick: handleHistoryClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 历史记录 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isBatchEditAccount))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 14,
              type: "primary",
              size: "medium",
              onClick: handleBatchEditAccountClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 批量修改账号 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isBatchEditCustomer))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 15,
              type: "primary",
              size: "medium",
              onClick: handleBatchEditCustomerClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 批量转移客户 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isBatchEditPoint))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 16,
              type: "primary",
              size: "medium",
              onClick: handleBatchEditPointClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 批量添加积分 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isBatchUpdateChannel))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 17,
              type: "primary",
              size: "medium",
              onClick: handleBatchUpdateChannelClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 批量更新渠道 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isFinance))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 18,
              type: "primary",
              size: "medium",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleVoiceFinance(dataList.value)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 财务数据导出 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isExport))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 19,
              type: "primary",
              size: "medium",
              onClick: handleVoiceExport
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 导出超时通话 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isExport))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 20,
              type: "primary",
              size: "medium",
              onClick: handleVoiceSum
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 下载汇总 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isExport))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 21,
              type: "primary",
              size: "medium",
              onClick: handleEveryDay
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 下载每日汇总 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isExport))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 22,
              type: "primary",
              size: "medium",
              onClick: handleVoiceDetail
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 下载明细 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isExportDetail))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 23,
              type: "primary",
              size: "medium",
              onClick: handleVoiceDetail
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 下载明细 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isExportOvertimeData))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 24,
              type: "primary",
              size: "medium",
              onClick: handleOvertimeData,
              title: "汇总18点以后通话一分钟以上的数据"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 加班通话汇总 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isExportWorktimeData))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 25,
              type: "primary",
              size: "medium",
              onClick: handleWorktimeData,
              title: "汇总8:30到17:00通话一分钟以上的数据"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 工作时间通话汇总 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isBatchDelete))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 26,
              type: "primary",
              size: "medium",
              onClick: handleBatchDeleteClick
            }, {
              default: _withCtx(() => [
                _createTextVNode("选中后可批量删除")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isBatchSet))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 27,
              type: "primary",
              size: "medium",
              onClick: handleBatchSetClick
            }, {
              default: _withCtx(() => [
                _createTextVNode("批量设为长效素材")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isBatchCancel))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 28,
              type: "primary",
              size: "medium",
              onClick: handleBatchCancelClick
            }, {
              default: _withCtx(() => [
                _createTextVNode("批量取消长效素材")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isExportMaterial))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 29,
              type: "primary",
              size: "medium",
              onClick: handleMaterialSum
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 下载汇总 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isYbwaveExportSum))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 30,
              type: "primary",
              size: "medium",
              onClick: handleYbwaveSum
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 下载汇总 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isYbwaveExportDetail))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 31,
              type: "primary",
              size: "medium",
              onClick: handleYbwaveDetail
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 下载表格 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isYbwaveDownloadImport))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 32,
              type: "primary",
              size: "medium",
              onClick: handleYbwaveDownloadImport
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 下载模板 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isActivityRanking))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 33,
              type: "primary",
              size: "medium",
              onClick: handleActivityRankingClick
            }, {
              default: _withCtx(() => [
                _createTextVNode("活跃用户排行 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isHotRanking))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 34,
              type: "primary",
              size: "medium",
              onClick: handleHotRankingClick
            }, {
              default: _withCtx(() => [
                _createTextVNode("热门功能排行 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isYbwaveImport))
          ? (_openBlock(), _createBlock(_component_el_upload, {
              key: 35,
              style: {"display":"inline-block","margin-left":"10px","margin-right":"10px"},
              action: _ctx.contentTableConfig.action,
              headers: headers.value,
              accept: ".xls,.xlsx",
              "on-success": handleImportSuccess,
              "on-error": handleImportError,
              "show-file-list": false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  size: "medium",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("点击上传")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["action", "headers"]))
          : _createCommentVNode("", true),
        (_unref(isExportStatistic))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 36,
              type: "primary",
              size: "medium",
              onClick: handleExportStatistic
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 导出汇总数据 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isExportStatisticDetail))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 37,
              type: "primary",
              size: "medium",
              onClick: handleExportStatisticDetail
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 导出互动明细 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isLoadScript))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 38,
              type: "danger",
              size: "medium",
              loading: isScriptLoading.value,
              onClick: handleLoadScript
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 运行统计（手动） ")
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        (_unref(isShowColumn))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 39,
              type: "warning",
              size: "medium",
              onClick: handleColumnShow
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 显示列 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isInitImport))
          ? (_openBlock(), _createBlock(_component_el_upload, {
              key: 40,
              style: {"display":"inline-block","margin-left":"10px","margin-right":"10px"},
              action: _ctx.contentTableConfig.action,
              headers: headers.value,
              accept: ".xls,.xlsx",
              "on-success": handleImportSuccess,
              "on-error": handleImportError,
              "show-file-list": false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  size: "medium",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("初始导入")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["action", "headers"]))
          : _createCommentVNode("", true),
        (_unref(isImportData))
          ? (_openBlock(), _createBlock(_component_el_upload, {
              key: 41,
              style: {"display":"inline-block","margin-left":"10px","margin-right":"10px"},
              action: _ctx.contentTableConfig.action,
              headers: headers.value,
              accept: ".xls,.xlsx",
              "on-progress": handleImportProgress,
              "on-success": handleImportSuccess,
              "on-error": handleImportError,
              "show-file-list": false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  size: "medium",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("导入数据")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["action", "headers"]))
          : _createCommentVNode("", true),
        (_unref(isFinanceDownload))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 42,
              type: "primary",
              size: "medium",
              onClick: handleFinanceDownload
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 财务导出 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isQuery))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 43,
              icon: "el-icon-refresh",
              onClick: refreshFunc
            }))
          : _createCommentVNode("", true)
      ]),
      createdTime: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatTime(scope.row.createdTime)), 1)
      ]),
      updatedTime: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatTime(scope.row.updatedTime)), 1)
      ]),
      handler: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_1, [
          (_unref(isQrcode))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                icon: "el-icon-full-screen",
                onClick: ($event: any) => (handleQrCodeClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("二维码下载")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(isUpdate))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "text",
                icon: "el-icon-edit",
                onClick: ($event: any) => (handleEditClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("编辑")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(isGoToAliyun))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                type: "text",
                icon: "el-icon-edit",
                onClick: ($event: any) => (handleGoToAliyunClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("前往阿里云")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(isConfig))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 3,
                type: "text",
                icon: "el-icon-edit",
                onClick: ($event: any) => (handleConfigClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("字典配置")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(isConfigUnionId))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 4,
                type: "text",
                icon: "el-icon-connection",
                onClick: ($event: any) => (handleConfigUnionIdClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("关联unionId")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (showVerifyButton(scope.row))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 5,
                type: "text",
                icon: "el-icon-edit",
                onClick: ($event: any) => (handleVerifyClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("核实")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (showRevokeButton(scope.row))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 6,
                type: "text",
                icon: "el-icon-back",
                onClick: ($event: any) => (handleRevokeClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("撤销核实")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (showCrossButton(scope.row))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 7,
                type: "text",
                icon: "el-icon-edit",
                onClick: ($event: any) => (handleCrossClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("审批")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(isDetail))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 8,
                type: "text",
                icon: "el-icon-edit",
                onClick: ($event: any) => (handleDetailClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查看/编辑")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(isView))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 9,
                type: "text",
                icon: "el-icon-view",
                onClick: ($event: any) => (handleViewClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查看")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (showDeleteButton(scope.row))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 10,
                type: "text",
                icon: "el-icon-delete",
                onClick: ($event: any) => (handleDeleteClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(isReset))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 11,
                type: "text",
                icon: "el-icon-edit",
                onClick: ($event: any) => (handleResetClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置密码")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(isRtContent))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 12,
                type: "text",
                icon: "el-icon-edit",
                onClick: ($event: any) => (handleRtContentClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("编辑内容")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(columnEdit))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 13,
                type: "text",
                icon: "el-icon-edit",
                onClick: ($event: any) => (handleEditColumns(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("列维护")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(createTable))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 14,
                type: "text",
                icon: "el-icon-edit",
                onClick: ($event: any) => (handleCreateTable(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.isGenerate == 0 ? '实体表生成' : '重新生成'), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      _renderList(_unref(otherPropSlots), (item) => {
        return {
          name: item.slotName,
          fn: _withCtx((scope) => [
            _renderSlot(_ctx.$slots, item.slotName, {
              row: scope.row
            })
          ])
        }
      })
    ]), 1040, ["listData", "listCount", "page", "tooltip"])
  ], 32))
}
}

})